<template lang="pug">
  div(v-if="menuItems.length")
    .row.d-flex.ma-0(v-for="(itemMenu, indexMenu) in menuItems" :key="itemMenu.id")
      v-col.border-col-rigth.pt-2.pb-2.align-center.justify-center(cols="3")
        span &nbsp;
      v-col.border-col-rigth.pt-2.pb-2.text-end.colMenu(cols="2")
        translate.mr-4.end_date {{itemMenu.end_date}}
      v-col.border-col-rigth.pt-2.pb-2.colMenu.colMenuName(cols="4")
        v-tooltip(right color="#fff" nudge-bottom="40" :open-delay="1000" content-class="tooltip-name" transition="slide-x-transition")
          template(v-slot:activator="{ on, attrs }")
            div.ml-4.name.text-truncate(v-bind="attrs" v-on="on") {{ itemMenu.name }}
          .tooltip
            span {{ itemMenu.name }}
            br
            span {{ itemMenu.description }}
      v-col.border-col-rigth.pt-2.pb-2.text-end.font-weight-med.colMenu(cols="1")
        span {{itemMenu.price  | formatNumber(2,2) }} €
      v-col.border-col-rigth.pt-2.pb-2.text-center.numberCentersMenuItem.colMenu(cols="2")
        span.cursor-pointer(@click="$emit('showDetailsMenuItem', itemMenu)") {{itemMenu.n_centers}} #[translate Restaurants]
</template>

<script>
export default {
  name: "PromoMenuList",
  props: {
    menuItems: {
      type: Array,
      required: true,
      default: () => []
    }
  }
}
</script>

<style lang="scss" scoped>
.colMenu{
  border-bottom: 1px solid #D9DFE8;
  font-size: 0.813rem;
}

.numberCentersMenuItem{
  text-align: right;
  color:var(--v-terciary-base);
}
</style>
